import { render, staticRenderFns } from "./DriverQuestion.vue?vue&type=template&id=2bd81e6f&scoped=true&xmlns%3Av-slot=http%3A%2F%2Fwww.w3.org%2F1999%2FXSL%2FTransform&"
import script from "./DriverQuestion.vue?vue&type=script&lang=js&"
export * from "./DriverQuestion.vue?vue&type=script&lang=js&"
import style0 from "./DriverQuestion.vue?vue&type=style&index=0&id=2bd81e6f&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bd81e6f",
  null
  
)

export default component.exports